
import { Mixins, Component } from "vue-property-decorator";
import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";
import ETable from "@/components/ETable.vue";
import AddOrganDialog from "./add-organ.vue"; // 假设你会创建一个 add-organ.vue 文件
import { consultationOrganList } from "@/api/consultation";

import { cloneDeep } from "lodash"

@Component({
    components: {
        ETable,
        AddOrganDialog
    }
})
export default class OrganList extends Mixins(TablePagination, Resize) {
    columns = [
        { label: "五脏名称", prop: "name" },
        { label: "五脏解释", prop: "fiveVisceraExplain" },
        { label: "五脏调养", prop: "visceraNurse" },
        { label: "表里关系", prop: "relationships" },
        { label: "关联经络", formatter:(row) => `${row.yinMeridianInside}/${row.yangMeridianSurface}` },
        { label: "操作人", prop: "modifiedBy" },
        { label: "最后操作时间", prop: "modifiedTime" },
        {
            label: "操作",
            prop: "action",
            width: 100,
        },
    ];

    tableData = [];
    itemTotal = 0;
    loading = false;
    addOrganDialogVisible = false;

    editData = {}

    mounted() {
        this.windowResize(350);
        this.getOrganList();
    }

    // 示例：获取脏腑列表数据
    getOrganList() {
        this.loading = true;
        // 实际开发中，这里会调用后端接口获取数据
        consultationOrganList().then((res) => {
            this.tableData = res.data;
            this.loading = false;
        });
    }

    handleSizeChange(val: number) {
        this.pageSize = val;
        this.getOrganList();
    }

    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.getOrganList();
    }

    handleAdd() {
        this.addOrganDialogVisible = true;
        // 这里可以传递数据给弹窗，例如是否为新增模式
    }

    handleEdit(row: any) {
        this.addOrganDialogVisible = true;
        // 这里可以传递当前行的数据给弹窗，用于编辑
        console.log("编辑行：", row);
        this.editData = cloneDeep(row)

    }
}
